﻿window.userpiketreport = function () {
    var dateTimeErrorMessageLabel = "";

    /*
    * Show / Hide Period Selector
    **/
    function setVisibilityPeriodSelector() {
        var timeinterval_value = parseInt($("#TimeInterval").data("kendoDropDownList").value());

        if (timeinterval_value == timeIntervalEnum.AskedPeriod) {
            $("#periodSelector").show();
        } else {
            $("#periodSelector").hide();
        }
    }

    return {
        /**
        * Initialize
        */
        initialize: function (dateTimeErrorMessage) {
            dateTimeErrorMessageLabel = dateTimeErrorMessage;

            main.setHideDiv("errorMessage", false);         
            $("#UserPiketReportExportButtonLoader").hide();
            setVisibilityPeriodSelector();
        },

        /**
        * onChange for TimeInterval (show / hide periodSelector)
        * @param { any } e
        */
        onChangeTimeInterval: function (e) {
            setVisibilityPeriodSelector();
        },

        /**
        * Action export (will download excel document according to the selected period)
        * @param { any } DOMelement
        */
        exportAction: function (DOMelement) {
            //stop the browser from following
            DOMelement.preventDefault();

            main.setHideDiv("errorMessage", false);

            // Show the waiting indicator
            $("#UserPiketReportExportButtonLoader").show();

            // get preference / options selected
            var selectedGroupId = parseInt($("#GroupId").data("kendoDropDownList").value());
            var selectedInterval = parseInt($("#TimeInterval").data("kendoDropDownList").value());

            // Get selection period
            var beginPeriodSelection = timeinterval.GetBeginPeriodSelection(selectedInterval, "StartSelection");
            if (beginPeriodSelection != null) {
                beginPeriodSelection = beginPeriodSelection.toUTCString();
            }

            var endPeriodSelection = timeinterval.GetEndPeriodSelection(selectedInterval, "EndSelection");
            if (endPeriodSelection != null) {
                endPeriodSelection = endPeriodSelection.toUTCString();
            }

            if (beginPeriodSelection != null && endPeriodSelection != null) {
                // Download File
                $.fileDownload(appsettings.getLocalUrl('UserPiketReport/Export?groupId=' + selectedGroupId + "&timeInterval=" + selectedInterval + "&start=" + beginPeriodSelection + "&end=" + endPeriodSelection))
                    .done(function () { $("#UserPiketReportExportButtonLoader").hide(); })
                    .fail(function () { $("#UserPiketReportExportButtonLoader").hide(); });
            }
            else {
                // Hide Indicator
                $("#UserPiketReportExportButtonLoader").hide();

                // make a message
                main.setHideDiv("errorMessage", true);

                var lblError = $("#errorMessageLabel");
                if (lblError != null && lblError != undefined) {
                    lblError.text(dateTimeErrorMessageLabel);
                }
            }
        },
        

        /**
        * Checks Passwordfield and Pasword2 field have identical values.
        * Is called on leaving Password2 field.
        * @param { any } DOMelement
        */
        startChange: function () {
            var start = $("#StartSelection").data("kendoDateTimePicker");
            var end = $("#EndSelection").data("kendoDateTimePicker");
            var startDate = start.value();
            var endDate = end.value();

            if (startDate) {
                startDate = new Date(startDate);
                startDate.setDate(startDate.getDate());
                end.min(startDate);
            } else if (endDate) {
                start.max(new Date(endDate));
            } else {
                endDate = new Date();
                start.max(endDate);
                end.min(endDate);
            }
        },

        /**
        * Checks Passwordfield and Pasword2 field have identical values.
        * Is called on leaving Password2 field.
        * @param { any } DOMelement
        */
        endChange: function () {
            var start = $("#StartSelection").data("kendoDateTimePicker");
            var end = $("#EndSelection").data("kendoDateTimePicker");
            var endDate = end.value();
            var startDate = start.value();

            if (endDate) {
                endDate = new Date(endDate);
                endDate.setDate(endDate.getDate());
                start.max(endDate);
            } else if (startDate) {
                end.min(new Date(startDate));
            } else {
                endDate = new Date();
                start.max(endDate);
                end.min(endDate);
            }
        }
    }
}();